import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AuthenticateUserMutation } from "./AuthenticateUser";

import { LoadingButton } from "@mui/lab";
import { useAuth } from "./AuthContext";
import useAlert from "../../core/useAlert";
import ReCAPTCHA from "react-google-recaptcha";
import HomeCarousel from "./HomeCarousel";

export interface LoginProps { }
interface LoginInput {
  userName: string;
  password: string;
  loginIp?: string;
}

const Login: React.FC<LoginProps> = () => {
  const captchaRef = React.useRef<any>();
  const formValuesRef = React.useRef<LoginInput | null>(null);
  const [loading, setLoading] = React.useState(false);
  const { login } = useAuth();
  const showAlert = useAlert();

  const defaultValues: LoginInput = {
    userName: "",
    password: "",
    loginIp: "",
  };
  const schema = yup.object().shape({
    userName: yup.string().required("Required").email("Invalid Email"),
    password: yup.string().required("Required"),
  });
  const submit = (values: LoginInput) => {
    AuthenticateUserMutation(values, {
      onSuccess: (response: any) => {
        const userDetails = response?.data?.viewer?.userDetails;
        const businessList = response?.data?.viewer?.businessList;
        // const authToken = businessList?.[0]?.authToken! ?? "";
        const authToken = businessList?.[0]?.userRoles?.roles?.[0]?.roleDetails?.authToken ??
          businessList?.[0]?.locations?.[0]?.userRoles?.roles?.[0]?.roleDetails?.authToken!
        const refreshToken = userDetails?.refreshToken! ?? "";
        login(authToken, refreshToken);
        showAlert("SignIn Successfully!", {
          variant: "success",
        });
        // if (userDetails?.twoFactorAuth) {
        //   // dispatch(authActions.twoFactorStep1({ mobile, authToken, refreshToken }));
        //   // navigate("two-factor-step-1");
        // } else {
        //   login(authToken, refreshToken);
        //   showAlert("SignIn Successfully!", {
        //     variant: "success",
        //   });
        // }
      },
      onLoading: setLoading,
      onError: (error) => {
        console.log("error", error);
        showAlert(error, {
          variant: "error",
        });
      },
    });
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const onSubmit = (values: any) => {
    setLoading(true);
    formValuesRef.current = values;
    setLoading(true);

    if (captchaRef.current) {
      captchaRef.current.executeAsync();
    } else {
      submit(values);
    }
  };
  const onVerify = (recaptchaResponse: string | null) => {
    const params = {
      ...formValuesRef.current,
      recaptchaResponse,
    };

    submit(params as any);
  };
  return (
    <>

      <Card>

        <CardHeader title={<Typography>Sign In</Typography>} />
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField {...register("userName")} fullWidth placeholder="Email" />
                <Typography color={"error"}>{errors?.userName?.message!}</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register("password")}
                  fullWidth
                  type="password"
                  placeholder="Password"
                />
                <Typography color={"error"}>{errors?.password?.message!}</Typography>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ flexDirection: "row-reverse" }}>
            <LoadingButton
              sx={{ marginRight: 1 }}
              loading={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              Login
            </LoadingButton>
          </CardActions>
          {/* <ReCAPTCHA
          size="invisible"
          ref={captchaRef}
          sitekey={"6LephYMrAAAAAA9jDdphl-neQ4k87TU_9rtJ8esJ"}
          onChange={onVerify}
        /> */}
        </form>
      </Card>
    </>
  );
};

export default Login;
